module.exports = __webpack_public_path__ + "static/media/30-1.b215ebb7.mp3";